import React from "react";
import { Grid } from "@material-ui/core";
import "./PrivacyPolicy.css";
import { makeStyles, Typography, Container, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    minHeight: "100vh",
    backgroundColor: "#000",
    color: "#FECE00",
  },
  eklogo: {
    width: "400px",
    height: "150px",

    marginInline: "auto",
  },
  link: {
    color: "rgb(5, 99, 193)",
  },
  root: {
    width: "100%",
    backgroundColor: "#000",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginTop: "100px",
    },
  },
  title: {
    height: "auto",
    objectFit: "cover",
    [theme.breakpoints.down("xs")]: {
      width: "60%",
      display: "flex",
    },
    fontSize: "20px",
    alignItems: "center",
    color: "#FECE00",
    alignContent: "center",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "10%",
  },
  description: {
    color: "#FECE00",
  },
  link: {
    color: "rgb(5, 99, 193)",
  },
  footertitle: {
    color: "#FECE00",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      <Grid className={classes.mainContainer} container>
        <div className="Term_condition">
          <div>
            <div className="term_condition_head">
              <img
                className={classes.eklogo}
                src="/assets/images/c5m-dark.png"
                alt="eksplode!"
              />
              <h3>PRIVACY POLICY</h3>
              <p>Last revised July 09, 2024</p>
            </div>
            <Grid style={{ minHeight: "500vh" }} container>
              <div id="privacypolicy" className={classes.root}>
                <Container maxWidth="md">
                  <Box mb={2} className={classes.title}>
                    <h2>Continent 5 Media Group, Inc.</h2>
                  </Box>
                  <Box textAlign="justify">
                    <Typography className={classes.description} variant="body1">
                      Continent 5 Media Group, Inc. complies with all applicable
                      privacy laws. Our Privacy Policy is intended to explain
                      how we collect and use personal data when you use our
                      websites and to alert you to the rights you may have to
                      control how the personal data is gathered and used.
                    </Typography>
                    <br />
                    <Typography className={classes.description} variant="body1">
                      “Continent 5 Media,” “C5M,” “we,” “our,” and “us” refer to
                      Continent 5 Media Group, Inc., and “you” and “yours” refer
                      to visitors and users of our websites.
                    </Typography>
                    <br />
                    <Typography className={classes.description} variant="body1">
                      1.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Websites.
                      </span>{" "}
                      Our Terms of Use and Privacy Policy apply to the following
                      websites:
                    </Typography>
                    <br />
                    <Typography className={classes.description} variant="body1">
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.AskTheLawGuru.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.BigBangRecords.ca
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.C5M.world
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.Continent5Media.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.Continent5MediaGroup.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.CounterstrikeEntertainment.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.Decade2Publishing.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.eksplode.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.FederalLawWiz.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.GalaxieRecordsUSA.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.GalaxieMusic.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.GalleryAurora.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.ImpactRecords.ca
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.KleverBook.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.Mind4Law.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.OperationVegasIce.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.PaperJumsuit.com
                      </Link>
                      <br />
                      <Link
                        className={classes.link}
                        style={{ lineHeight: "40px" }}
                        href="#"
                      >
                        www.TitanMobileGaming.com
                      </Link>
                      <br />
                    </Typography>
                    <Typography className={classes.description}>
                      The owner of these websites is Continent 5 Media Group. To
                      contact us, please send an email to
                      <br />
                      <Link className={classes.link} href="#">
                        Admin@continent5media.com
                      </Link>{" "}
                      or{" "}
                      <Link className={classes.link} href="#">
                        Admin@c5m.world.
                      </Link>
                    </Typography>
                    <Typography className={classes.description}>
                      2.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Most Recent Update.
                      </span>{" "}
                      Our Terms of Use and Privacy Policy were last updated on
                      July 09, 2024. Please return to our Terms of Use and
                      Privacy Policy to determine if we have made any changes
                      since your last visit.
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      3.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Consent to Use of Cookies.{" "}
                      </span>
                      Like virtually all websites, our websites use “cookies”
                      that are automatically installed on your computer when you
                      visit our websites. Cookies are small text files stored on
                      your computer and can be recognized when you return to our
                      websites. Some cookies are installed by the service
                      providers who host and maintain our websites or
                      advertisers. The cookies will collect some of your
                      personal data. On the landing page, you will be allowed to
                      consent (or “opt-in”) to the use of cookies. If you do not
                      opt-in, or if you opt-in but later remove or turn off the
                      cookies, the website(s) will not be fully functional.
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      4.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Consent to Terms of Use and Privacy Policy.
                      </span>{" "}
                      When you purchase products or services through C5M’s
                      websites, you will be asked to confirm that you agree to
                      be bound by our Terms of Use and Privacy Policy. If you
                      disagree, you will not be able to complete the purchase.
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      5.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Consent Based on Your Use of Our Websites.
                      </span>{" "}
                      Even if you do not consent to be bound by our Terms of Use
                      and Privacy Policy at the time of purchase, please be
                      aware that we will rely on your continued use of our
                      websites to confirm your consent to be bound if applicable
                      law permits us to do so. Your consent applies to our Terms
                      of Use and Privacy Policy, which may be updated
                      occasionally. Please do not visit our websites if you do
                      not want to be bound.
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      6.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Personal Data.
                      </span>{" "}
                      Here is a summary of how we acquire and use visitors’ data
                      on our websites.
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;We collect some personal data
                        through cookies when you register as a user of our
                        website(s) and when you purchase products and services
                        through our websites.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;The personal data we collect
                        and process may include your name, IP address,
                        geolocation information, passwords, email addresses,
                        mailing addresses, telephone numbers, professional
                        status, transaction, and traffic data.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (c)&nbsp;&nbsp;&nbsp;&nbsp;;We do not currently collect
                        sensitive personal information such as Social Security
                        numbers, age, driver’s license numbers, usernames, or
                        information on race, ethnicity, religious or
                        philosophical beliefs. Please monitor our Terms of Use
                        and Privacy Policy for any changes in the future.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (d)&nbsp;&nbsp;&nbsp;&nbsp;We act as the controller of
                        the personal data we collect, and we may enter into
                        written contracts with service providers who assist us
                        in processing personal data..
                      </span>
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      7.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        What We Do with Your Personal Data.
                      </span>{" "}
                      As a general rule, we use your personal data only for the
                      purposes described in this Privacy Policy and only to the
                      extent that our use of your personal data is reasonable
                      and relevant to these purposes.
                    </Typography>
                    <br />
                    <Typography className={classes.description} variant="body1">
                      <span style={{ padding: "2.5rem" }}>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;We use your personal data
                        only for the following purposes: (a) Monitoring and
                        maintaining the functionality of our websites to make
                        sure it is operating correctly; (b) Communicating with
                        our customers and websites, visitors, and users; (c)
                        Market research and marketing of the products and
                        services of C5M and its subsidiaries; and (iv) Detecting
                        any use of our websites that violates our Terms of Use.
                      </span>
                      <br />

                      <span style={{ padding: "2.5rem" }}>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;We do not keep personal data
                        any longer than is necessary for business purposes, and
                        we delete personal data when it is no longer required.
                      </span>

                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (c)&nbsp;&nbsp;&nbsp;&nbsp;We use our commercially
                        reasonable best efforts to maintain the security of the
                        personal data that we collect and use.
                      </span>

                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (d)&nbsp;&nbsp;&nbsp;&nbsp;We do not buy or sell
                        personal data or share personal data except with third
                        parties who agree to comply with applicable privacy
                        laws.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (e)&nbsp;&nbsp;&nbsp;&nbsp;We do not use automated
                        decision-making technology like “profiling.”
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (f)&nbsp;&nbsp;&nbsp;&nbsp;We use your data to
                        communicate with you on our websites and by email to
                        inform you of the information, products, and services
                        available through C5M, to provide customer service, and
                        to conduct surveys.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (g)&nbsp;&nbsp;&nbsp;&nbsp;We reserve the right to
                        retain and disclose personal data (i) when we are
                        legally required to do so by law or court order, (ii)
                        when it is necessary to do so to enforce the Terms of
                        Use, and/or (iii) to protect the rights, safety or
                        security of C5M, our advertisers and affiliates, and our
                        employees, contractors, and vendors.
                      </span>
                    </Typography>

                    <Typography className={classes.description} variant="body1">
                      8.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Your Privacy Rights.
                      </span>{" "}
                      Depending on what laws apply to your use of our websites
                      and our collection of personal data, which may change from
                      time to time in the future, you may have the following
                      rights regarding your personal data, and you may exercise
                      any of the rights you have by contacting our Data
                      Protection Officer at{" "}
                      <Link href="#" className={classes.link}>
                        Admin@Continent5Media.com
                      </Link>{" "}
                      or <Link className={classes.link}>Admin@C5M.com</Link>:
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;The right to withdraw your
                        consent to using cookies.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;The right to withdraw your
                        consent to collecting and processing your personal data.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (c)&nbsp;&nbsp;&nbsp;&nbsp;The right to request a copy
                        of your personal data that we have collected.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (d)&nbsp;&nbsp;&nbsp;&nbsp;The right to update, correct,
                        change, block, or erase your personal data.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (e)&nbsp;&nbsp;&nbsp;&nbsp;The right to transfer some or
                        all of your personal data to another data controller.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (f)&nbsp;&nbsp;&nbsp;&nbsp;The right to limit the use
                        and disclosure of sensitive personal information.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (g)&nbsp;&nbsp;&nbsp;&nbsp;The right to opt out of
                        receiving marketing communications from us by email.
                      </span>
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      9.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Privacy Policy for Minors.{" "}
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;Some of our websites offer
                        programs and content that are intended for use by
                        children but only with the consent and under the
                        supervision of their parents or guardians. However,
                        access to the content allows for purchases of products
                        and services, and only users 18 years or older are
                        permitted to make purchases. We rely on these users to
                        decide whether our content is appropriate for any minor
                        with whom the content will be shared.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;We do not knowingly collect
                        personal data from minors.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (c)&nbsp;&nbsp;&nbsp;&nbsp;Individuals under the age of
                        thirteen must ask their parent or guardian for
                        permission to use our websites,
                      </span>
                      <br />
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      10.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Scope of Privacy Policy.{" "}
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (a)&nbsp;&nbsp;&nbsp;&nbsp;Our Privacy Policy applies
                        only to personal data we collect when you visit and use
                        our websites and not to information we collect through
                        our offline business.
                      </span>
                      <br />
                      <span style={{ padding: "2.5rem" }}>
                        (b)&nbsp;&nbsp;&nbsp;&nbsp;Our Privacy Policy does not
                        apply to other websites that may be linked to our
                        websites, including websites operated by advertisers and
                        other third parties. If you leave our website(s) and go
                        to another, please read the Terms of Use and Privacy
                        Policy posted on the other website.
                      </span>
                    </Typography>
                    <Typography className={classes.description} variant="body1">
                      11.
                      <span style={{ fontWeight: "bold", marginLeft: "2rem" }}>
                        Contact.
                      </span>{" "}
                      If you have questions about our Terms of Use and Privacy
                      Policy, don't hesitate to contact the Data Privacy Officer
                      for C5M at
                      <Link href="#" className={classes.link}>
                        {" "}
                        Admin@Continent5Media.com
                      </Link>{" "}
                      or <Link className={classes.link}>Admin@C5M.com</Link>:
                    </Typography>
                    <br />
                    <br />
                    <br />
                    <Typography className={classes.footertitle} variant="body1">
                      – End of Privacy Policy – <br />
                      Last Updated July 09, 2024
                    </Typography>
                  </Box>
                </Container>
              </div>
            </Grid>
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default PrivacyPolicy;
